import { GeneratedFormSpecTypes } from '@/utils/types/generatedForm'
import ManagerName, { specPerizinanManagerName } from './perizinan/ManagerName'
import StartProcessCustom, { specPerizinanPilihJam } from './perizinan/StartProcessCustom'
import UploadBuktiPendukungField, { specUploadBuktiPendukung } from './perizinan/UploadBuktiPendukungField'
import TotalJamLemburField, { specPengajuanLembur } from './pengajuanLembur/TotalJamLemburField'
import InputMakanSiangField from './prosesKehadiranMakanSiang/InputMakanSiangField'
import { specInputAlasanTerlambat, specInputMakanSiang } from './prosesKehadiranMakanSiang/spec'
import InputAlasanTerlambat from './prosesKehadiranMakanSiang/InputAlasanTerlambat'
import DepartmentName, { specDepartmentName } from './pengajuanReimburse/DepartmentName'
import PengajuanDinasStartPilihJam, {
  specPengajuanDinasStartPilihJam,
} from './pengajuanPerjalanDinas/PengajuanDinasStartPilihJam'
import JobPosition, { specJobPosition } from './perizinan/JobPosition'
import Account from './expenses/Account'
import { accountSpec } from './expenses/AccountSpec'
import { categorySpec } from './expenses/CategorySpec'
import Category from './expenses/Category'
import { tableTerminSpec } from './tableTermin/TableTerminSpec'
import TableTermin from './tableTermin/TableTermin'
import QuotaAvailability from './perizinan/QuotaAvailability'
import { quotaAvailabilitySpec } from './perizinan/QuotaAvailabilitySpec'
import NominalUangSaku from './pengajuanPerjalanDinas/NominalUangSaku'
import { nominalUangSakuSpec } from './pengajuanPerjalanDinas/NominalUangSakuSpec'
import EmployeeName from './perizinan/EmployeeName'
import { employeeNameSpec } from './perizinan/EmployeeNameSpec'
import { lemburManagerNameSpec } from './pengajuanLembur/LemburManagerNameSpec'
import LemburManagerName from './pengajuanLembur/LemburManagerName'
import ListEmployeeName from './Softloan/ListEmployeeName'
import { listEmployeeNameSpec } from './Softloan/ListEmployeeNameSpec'
import { listCompanyNameSpec } from './payroll/ListCompanyNameSpec'
import ListCompanyName from './payroll/ListCompanyName'
import KeyActivitiesJobDesc from './kpiBulanan/KeyActivitiesJobDesc'
import { keyActivitiesJobDescSpec } from './kpiBulanan/KeyActivitiesJobDescSpec'
import DownloadTemplateTim from './kpiLeadership/DownloadTemplateTim'
import DownloadTemplateDirector from './kpiLeadership/DownloadTemplateDirector'
import MengisiLaporanKpiLeadershipVariableRenderer from './kpiLeadership/MengisiLaporanKpiLeadershipVariableRenderer'
import DownloadTemplateKpiGrd from './kpiGrd/DownloadTemplateKpiGrd'
import { mengisiLaporanKpiLeadershipSpec } from './kpiLeadership/spec'
import HideManagerName from './shared/HideManagerName'
import { hideManagerSpec } from './shared/spec'
import MeninjauKPIBulananSoftSkill from './kpiBulanan/MeninjauKPIBulananSoftSkill'
import HideDepartmentName, { specHideDepartmentName } from './shared/HideDepartmentName'
import MeninjauKPIPerformance from './kpiBulanan/MeninjauKPIPerformance'
import InputMultiFileUpload from './shared/InputMultiFileUpload'
import CurrentProfile, { specCurrentProfile } from '@/components/tasklist/forms/customComponents/profile/CurrentProfile'

export default {
  PENGAJUAN_IZIN_START_PILIH_JAM: StartProcessCustom,
  MANAGER_NAME: ManagerName,
  JOB_POSITION: JobPosition,
  BUKTI_PENDUKUNG_FIELD: UploadBuktiPendukungField,
  TOTAL_JAM_LEMBUR_FIELD: TotalJamLemburField,
  IS_LUNCH_AT_OFFICE: InputMakanSiangField,
  REASON_LATE: InputAlasanTerlambat,
  DEPARTMENT_NAME: DepartmentName,
  PENGAJUAN_DINAS_START_PILIH_JAM: PengajuanDinasStartPilihJam,
  ACCOUNT_ID: Account,
  CATEGORY_ID: Category,
  TABLE_TERMIN: TableTermin,
  QUOTA_AVAILABILITY: QuotaAvailability,
  nominal_uang_saku: NominalUangSaku,
  EMPLOYEE_NAME: EmployeeName,
  MANAGER_NAME_LEMBUR: LemburManagerName,
  LIST_EMPLOYEE_NAME: ListEmployeeName,
  LIST_COMPANY_NAME: ListCompanyName,
  keyActivitiesJobDesc: KeyActivitiesJobDesc,
  KPI_LEADERSHIP_TEMPLATE_TIM: DownloadTemplateTim,
  KPI_LEADERSHIP_TEMPLATE_DIRECTOR: DownloadTemplateDirector,
  MENGISI_LAPORAN_KPI_LEADERSHIP_VARIABLE_RENDERER: MengisiLaporanKpiLeadershipVariableRenderer,
  KPI_GRD: DownloadTemplateKpiGrd,
  HIDE_MANAGER_NAME: HideManagerName,
  HIDE_DEPARTMENT_NAME: HideDepartmentName,
  PROSES_PEMANTAUAN_KPI_BULANAN_VARIABLE_RENDERER: MeninjauKPIBulananSoftSkill,
  MENINJAU_KPI_PERFORMANCE_VARIABLE_RENDERER: MeninjauKPIPerformance,
  INPUT_MULTI_FILE_UPLOAD: InputMultiFileUpload,
  CURRENT_PROFILE: CurrentProfile
}

export const customSpecComponent: { [key: string]: GeneratedFormSpecTypes[] } = {
  PENGAJUAN_IZIN_START_PILIH_JAM: specPerizinanPilihJam,
  MANAGER_NAME: specPerizinanManagerName,
  JOB_POSITION: specJobPosition,
  BUKTI_PENDUKUNG_FIELD: specUploadBuktiPendukung,
  TOTAL_JAM_LEMBUR_FIELD: specPengajuanLembur,
  IS_LUNCH_AT_OFFICE: specInputMakanSiang,
  REASON_LATE: specInputAlasanTerlambat,
  DEPARTMENT_NAME: specDepartmentName,
  PENGAJUAN_DINAS_START_PILIH_JAM: specPengajuanDinasStartPilihJam,
  ACCOUNT_ID: accountSpec,
  CATEGORY_ID: categorySpec,
  TABLE_TERMIN: tableTerminSpec,
  QUOTA_AVAILABILITY: quotaAvailabilitySpec,
  nominal_uang_saku: nominalUangSakuSpec,
  EMPLOYEE_NAME: employeeNameSpec,
  MANAGER_NAME_LEMBUR: lemburManagerNameSpec,
  LIST_EMPLOYEE_NAME: listEmployeeNameSpec,
  LIST_COMPANY_NAME: listCompanyNameSpec,
  keyActivitiesJobDesc: keyActivitiesJobDescSpec,
  MENGISI_LAPORAN_KPI_LEADERSHIP_VARIABLE_RENDERER: mengisiLaporanKpiLeadershipSpec,
  HIDE_MANAGER_NAME: hideManagerSpec,
  HIDE_DEPARTMENT_NAME: specHideDepartmentName,
  CURRENT_PROFILE: specCurrentProfile,
}
